/**
 * @module support/shared/widgets
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

/**
 * A T-mobile customm design legalText component.
 * A tmo-legal-text component can be used overall the application to display the legal disclaimer
 * which is fetched from AEM
 */

import { Component, OnInit, Input, OnDestroy } from '@angular/core';
@Component({
  selector: 'tmo-legal-text',
  templateUrl: './legal-text.component.html',
})
export class LegalTextComponent implements OnInit, OnDestroy {
  /**
   * Boolean property to enable the seeMore/seeLess functionality.
   */
  public seeAll: boolean;
  /**
   * String input property to show the legalText title.
   */
  @Input() public legalTitle: String;
  /**
   * String input property to show the legalContent title.
   */
  @Input() public legalContent: String;

  /**
   * String input property to enable the seeMore/seeLess functionality.
   */
  @Input() public hidden: boolean;

  /**
   * Configurable value if we require the divider line
   * @returns boolean
   */
  @Input() public noDivider?: boolean;

  /**
   * Whenever this component needs some value to be instantiated on load then
   * values of its properties are initialised in the constructor
   * @returns void
   */
  constructor() {
    this.seeAll = false;
  }
  /**
   * Called whenever this component is invoked from parent component
   * @returns void
   */
  public ngOnInit(): void {}
  /**
   * Method to enable the seeMore/seeLess functionality.
   * @returns void
   */
  public toggleFeatures(): void {
    this.seeAll = !this.seeAll;
  }

  /**
   * Destroys all the subscriptions .
   * @returns void
   */
  public ngOnDestroy(): void {}
}
